import React from 'react';
import { styled } from '@mui/material';

const Container = styled('div')({
  display: 'grid',
  gridGap: 7,
  alignItems: 'flex-start',
  gridAutoRows: 'min-content',
  gridTemplateColumns: '1fr',
});

const Card = styled('div')(({ theme }) => ({
  display: 'flex',
  flexDirection: 'column',
  backgroundColor: theme.palette.background.paper,
  padding: 15,
  '& div + div': {
    marginTop: 10,
  },
}));

const Item = styled('div')({
  width: '100%',
  height: 15,
});

const Item2 = styled('div')({
  width: '80%',
  height: 15,
});

const cards = Array(6).fill('');

const ModuleLoading: React.FC = () => {
  return (
    <Container>
      {cards.map((value, index) => (
        <Card key={index + value}>
          <Item className={`animated-background`} />
          <Item2 className={`animated-background`} />
          <Item className={`animated-background`} />
        </Card>
      ))}
    </Container>
  );
};

export default ModuleLoading;
